import "./style.scss";
import $ from "jquery";

$(document).ready(function () {
    var animated = false;
    $(window).scroll(function () {
        if ($('.count-up').isInViewport() && !animated) {
            $('.count-up__stevilka').each(function () {
                $(this).prop('Counter', 0).animate({
                    Counter: $(this).text()
                }, {
                    duration: 2000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
            });
            animated = true;
        }
    });
});

$.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();

    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
